// extracted by mini-css-extract-plugin
module.exports = {"button":"save-button_button__BIlBp","loading":"save-button_loading__ClBKe"};